export const paymentTypes = [
  {
    value: 0,
    title: "Готівка",
  },
  {
    value: 0,
    title: "Бонуси",
  },
  {
    value: 1,
    title: "Картка",
  },
];

export const maxClientCardsCount = 3;

export const maskCardNumber = (cardNumber: string): string => {
  if (cardNumber.length !== 16) {
    throw new Error("Невірний формат номера карти");
  }
  return "**** **** **** " + cardNumber.slice(-4);
};

export const shortCardNumber = (cardNumber: string): string => {
  if (cardNumber.length !== 16) {
    throw new Error("Невірний формат номера карти");
  }
  return "**** " + cardNumber.slice(-4);
};
